import { useState } from 'react';
import { useGroups } from '../../../hooks/useGroups';
import { useLegalEntities } from '../../../hooks/useLegalEntities';
import { useCouponsStatistics } from '../../../hooks/useStatistics';
import { INITIAL_FILTERS } from '../constants/statisticsConstants';

/**
 * Hook personalizado para manejar la lógica de estadísticas
 * Implementa TanStack Query y sigue los patrones del proyecto
 */
export const useStatistics = () => {
  // Datos externos usando TanStack Query
  const { data: groups = [] } = useGroups();
  const { data: legalEntities = [] } = useLegalEntities();

  // Estado local del componente
  const [filters, setFilters] = useState({
    ...INITIAL_FILTERS,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [results, setResults] = useState([]);
  const [header, setHeader] = useState([]);

  // Hook de mutación para obtener estadísticas
  const { mutateAsync: getStatistics } = useCouponsStatistics();

  /**
   * Maneja los cambios en los filtros
   */
  const handleFilterChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  /**
   * Maneja el envío del formulario y la obtención de datos
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await getStatistics(filters);
      const { results: apiResults, header: apiHeader } = response;

      // Verificar si el tipo de reporte requiere modal
      const reportTypesWithModals = [
        'fees_by_order',
        'deferred_coupons',
        'issued_coupons',
        'coupon_details_fer',
        'score_ranking',
        'sales',
        'debt_balances',
        'subscribers',
        'intermediate_entities_collection',
      ];

      if (reportTypesWithModals.includes(filters.reportType)) {
        setResults(apiResults);
        setHeader(apiHeader);
        setModalOpen(true);
      }
    } catch (err) {
      setError('Error al obtener los datos.');
      console.error('Error fetching statistics:', err);
    } finally {
      setLoading(false);
    }
  };

  /**
   * Cierra el modal
   */
  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return {
    // Estado del formulario
    filters,
    loading,
    error,

    // Datos de resultado
    results,
    header,
    modalOpen,

    // Datos externos
    groups,
    legalEntities,

    // Acciones
    handleFilterChange,
    handleSubmit,
    handleCloseModal,
  };
};
